const DetailCard = ({
  title,
  subtitle,
  children,
  headerAction,
  className = "",
  bodyClassName = "",
  flush = false,
}) => (
  <section
    className={`rounded-[8px] border border-[#EAECF0] bg-white ${className}`}
    style={{ boxShadow: "3.28px 3.28px 12.3px 0px #0000001A" }}
  >
    {(title || headerAction || subtitle) && (
      <div className="flex items-start justify-between gap-3 border-b border-[#EAECF0] bg-[#F5F8FF] px-4 py-3 sm:px-5">
        <div className="min-w-0">
          {title ? (
            <h3 className="text-[18px] font-bold text-[#18283D]">{title}</h3>
          ) : null}
          {subtitle ? (
            <p className="mt-0.5 text-[12px] leading-relaxed text-[#667085]">
              {subtitle}
            </p>
          ) : null}
        </div>
        {headerAction ? (
          <div className="shrink-0 self-center">{headerAction}</div>
        ) : null}
      </div>
    )}
    <div
      className={
        flush ? bodyClassName : `px-4 py-3 sm:px-5 ${bodyClassName}`
      }
    >
      {children}
    </div>
  </section>
);

export const DetailRow = ({ label, children, last = false }) => (
  <div
    className={`grid grid-cols-1 gap-1 py-2.5 text-[14px] sm:grid-cols-[150px_1fr] sm:items-start sm:gap-3 ${
      last ? "" : "border-b border-[#D9D9D9]"
    }`}
  >
    <span className="font-semibold text-[#18283D]">{label || "—"}</span>
    <div className="break-all text-[#18283D]">{children ?? "—"}</div>
  </div>
);

export const InfoTile = ({ label, value, hint }) => (
  <div className="rounded-[5px] border border-[#EAECF0] bg-[#FAFBFC] px-3.5 py-3">
    <p className="text-[11px] font-medium uppercase tracking-[0.05em] text-[#98A2B3]">
      {label}
    </p>
    <p className="mt-1.5 truncate text-[14px] font-semibold text-[#18283D]">
      {value ?? "—"}
    </p>
    {hint ? (
      <p className="mt-0.5 truncate text-[11px] text-[#667085]">{hint}</p>
    ) : null}
  </div>
);

export default DetailCard;
